import React, { PureComponent } from 'react';
import PropTypes, { arrayOf, func, shape } from 'prop-types';

import { Modal } from 'jl-design-system/components/modal/Modal';
import { ProductsForm } from '../products-form/ProductsForm';

import styles from './ProductFormModal.scss';

export class ProductFormModal extends PureComponent {
  onSaveHandler = (product) => {
    const { onClose, onSaveHandler } = this.props;
    onSaveHandler(product);
    onClose();
  };

  onSubmitHandler = (product) => {
    const { onClose, onSubmitHandler } = this.props;
    onSubmitHandler(product);
    onClose();
  };

  render() {
    const {
      productFormModalState: { isOpen, product },
      products,
      configs,
      onClose,
      clearErrorMessages,
    } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={`${product ? 'Edit' : 'Add another'} product`}
        className={styles.Modal}
        rootId="page-root"
        footer={false}
      >
        <ProductsForm
          key="productFormModal"
          editableProduct={product}
          products={products}
          configs={configs}
          isProductsListShown
          onClickCancelHandler={onClose}
          onSaveHandler={this.onSaveHandler}
          onSubmitHandler={this.onSubmitHandler}
          clearErrorMessages={clearErrorMessages}
        />
      </Modal>
    );
  }
}

export const MemoizedProductFormModal = React.memo(ProductFormModal);

ProductFormModal.propTypes = {
  onClose: func.isRequired,
  productFormModalState: shape({}),
  products: arrayOf(shape({})).isRequired,
  configs: PropTypes.shape({}).isRequired,
  onSaveHandler: func.isRequired,
  onSubmitHandler: func.isRequired,
  clearErrorMessages: func.isRequired,
};

ProductFormModal.defaultProps = {
  productFormModalState: {
    isOpen: false,
    product: {},
  },
};
